// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1iYJy","bigColWidth":"Table_bigColWidth__3Zq4O","biggerColWidth":"Table_biggerColWidth__LESw-","row":"Table_row__3wkTg","col":"Table_col__2zUxK"};